export default __webpack_public_path__ + "static/media/cross-concept.d130ca2d.svg";